import React from "react";
import { Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";

const CustomDropdown = ({
  items,
  placement = "bottomRight",
  trigger = ["click"],
  icon = <DownOutlined />,
  className,
  overlay,
  open,
  onOpenChange,
}) => {
  return (
    <Dropdown
      overlay={overlay}
      menu={{ items }}
      placement={placement}
      trigger={trigger}
      arrow
      open={open}
      onOpenChange={onOpenChange}
    >
      <span className={className} style={{ cursor: "pointer" }}>
        {icon}
      </span>
    </Dropdown>
  );
};

export default CustomDropdown;
